const parseTransitionNext = (next) => {
  if (next && typeof next === 'object') {
    return Object.keys(next).join(', ');
  }
  return next;
};

export default parseTransitionNext;
